import { ChatToggleProvider } from '../contexts/ChatToggleContext';
import { useProductContext } from '../contexts/ProductContext';
import FinalizeLifecareSummary from './FinalizeLifecareSummary';
import { useCallback } from 'react';

const FinalizeLifecareSummaryWrapper = () => {
    const {getFinalizeLifecareSummary} = useProductContext();

     const getFinalizeLifecareSummaryOverride = useCallback(() => {
      if (!getFinalizeLifecareSummary) {
         return FinalizeLifecareSummary;
      }
      const finalizeLifecareSummaryOverride = getFinalizeLifecareSummary();
      if (finalizeLifecareSummaryOverride) {
         return finalizeLifecareSummaryOverride;
      }
      return FinalizeLifecareSummary;
   }, [getFinalizeLifecareSummary]);

   const FinalizeLifecareSummaryOverride = getFinalizeLifecareSummaryOverride()

    return (
        <ChatToggleProvider>
            <FinalizeLifecareSummaryOverride />
        </ChatToggleProvider>
    );
};

export default FinalizeLifecareSummaryWrapper;
